import { render } from "./SelectControl.vue?vue&type=template&id=70dabdb4"
import script from "./SelectControl.vue?vue&type=script&lang=js"
export * from "./SelectControl.vue?vue&type=script&lang=js"

import exportComponent from "/home/malezha/zfort/digitalfax/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"SelectControl.vue"]])

export default __exports__